import React from "react";
import "./NewsSection.css";

const newsData = [
  {
    image: "/assets/news1.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title:
      "Sabre opens travel infrastructure to Silicon Valley developers building...",
    description:
      "The July 18 event in Mountain View will challenge developers to build travel AI agents...",
    link: "https://www.sabre.com/resources/newsroom/sabre-opens-travel-infrastructure-to-silicon-valley-developers-building-the-next-ai-agents-at-bay-area-hackathon/",
  },
  {
    image: "/assets/news2.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title:
      "Sabre scales agentic AI deployment as Ultra Group expands globally...",
    description:
      "Sabre announced a landmark technology deployment with Ultra Group...",
    link: "https://www.sabre.com/resources/newsroom/sabre-scales-agentic-ai-deployment-as-ultra-group-expands-globally-under-linex/",
  },
  {
    image: "/assets/news3.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title:
      "Mindtrip launches travel's first all-in-one agentic AI flight booking...",
    description:
      "Sabre announced an extension of its distribution representation agreement...",
    link: "https://www.sabre.com/resources/newsroom/mindtrip-launches-travels-first-all-in-one-agentic-ai-flight-booking-experience-powered-by-partnership-with-sabre-and-paypal/",
  },
  {
    image: "/assets/news4.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title:
      "Sabre appoints Niklas Andréen as Chief Commercial Officer, Airline...",
    description:
      "New leadership role underscores Sabre's commitment to accelerating airline growth...",
    link: "https://www.sabre.com/resources/newsroom/sabre-appoints-niklas-andreen-as-chief-commercial-officer-airline-tech/",
  },
  {
    image: "/assets/news5.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title:
      "Sabre unveils once-in-a-generation company rebuild and its AI-first...",
    description: "With its unified, AI-native cloud-based architecture...",
    link: "https://www.sabre.com/resources/newsroom/sabre-unveils-once-in-a-generation-company-rebuild-and-its-ai-first-platform-at-itb-berlin-2026/",
  },
  {
    image: "/assets/news6.png",
    category: "NEWSROOM",
    date: "24 JULY 2026",
    title: "From Content Complexity to Connected Retailing 7...",
    description:
      "Consumers fill their carts this season, the travel industry is contending...",
    link: "https://www.sabre.com/releases/from-content-complexity-to-connected-retailing-7-transformations-redefining-travel-in-2026-led-by-the-rise-of-agentic-ai/",
  },
];

function NewsSection() {
  return (
    <section className="news-section section-padding">
      <div className="news-pattern-left"></div>

      <div className="container">
        <div className="news-top">
          <div>
            <h2 className="heading-title news-title">
              News & <span className="title-blue">Announcements</span>
            </h2>

            <p className="news-desc">
              TNS Global, in partnership with Sabre Corporation, is expanding
              its Global Distribution System (GDS) across 14 high-growth.
            </p>
          </div>

          <a
            className="read-btn-a btn-flex"
            href="https://www.sabre.com/resources/newsroom"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="read-btn">
              Read All
              <img src="/assets/arrow.svg" alt="arrow" className="btn-arrow" />
            </button>
          </a>
        </div>

        <div className="row g-4">
          {newsData.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="res-news-card">
                <img
                  src={item.image}
                  alt={item.title}
                  className="res-news-image"
                />

                <div className="news-content">
                  <div className="res-news-meta">
                    <span>{item.category}</span>

                    <span>{item.date}</span>
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.description}</p>

                  <a
                    href={item.link}
                    className="news-read-more"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    READ MORE
                    <img src="/assets/read-arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <a
          className="read-btn-a btn-none"
          href="https://www.sabre.com/resources/newsroom"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="read-btn">
            Read All
            <img src="/assets/arrow.svg" alt="arrow" className="btn-arrow" />
          </button>
        </a>

      </div>
    </section>
  );
}

export default NewsSection;
